import React, { useState } from "react";
import { CreditCard, Store } from "lucide-react";
import { useSelector } from "react-redux";

const PaymentSection = ({ paymentMethod, setPaymentMethod }) => {
  return (
    <div>
      <h3 className="font-semibold text-lg mb-4">Payment</h3>

      <div className="space-y-3">
        {/* PAY AT STORE */}
        {/* <label
          className={`flex items-center justify-between border rounded-lg p-4 cursor-pointer transition 
          ${paymentMethod === "store" ? "bg-gray-100  border-gray-400" : "hover:border-gray-400"}`}
        >
          <div className="flex items-center gap-3">
            <Store size={18} />
            <span className="font-medium">Pay at store</span>
          </div>

          <input
            type="radio"
            name="payment"
            checked={paymentMethod === "store"}
            onChange={() => setPaymentMethod("store")}
          />
        </label> */}

        {/* PAY ONLINE */}
        <label
          className={`flex items-center justify-between border rounded-lg p-4 cursor-pointer transition 
          ${paymentMethod === "online" ? "bg-gray-100  border-gray-400" : "hover:border-gray-400"}`}
        >
          <div className="flex items-center gap-3">
            <CreditCard size={18} />
            <span className="font-medium">Pay online</span>

            <span className="text-xs bg-gray-200 px-2 py-1 rounded-md">
              Powered by Stripe
            </span>
          </div>

          <input
            type="radio"
            name="payment"
            checked={paymentMethod === "online"}
            onChange={() => setPaymentMethod("online")}
          />
        </label>
      </div>

      {/* CARD FORM */}
      {/* {paymentMethod === "online" && (
        <div className="border rounded-lg p-4 space-y-4 mt-4">
          <input
            placeholder="Card number"
            className="w-full border rounded-lg px-4 py-3"
          />

          <div className="grid grid-cols-2 gap-3">
            <input
              placeholder="Expiration date"
              className="border rounded-lg px-4 py-3"
            />
            <input
              placeholder="Security code"
              className="border rounded-lg px-4 py-3"
            />
          </div>

          <input
            placeholder="Name on card"
            className="border rounded-lg px-4 py-3 w-full"
          />
        </div>
      )} */}
    </div>
  );
};

export default PaymentSection;
